import { Component, Renderer2, OnInit, PLATFORM_ID, Inject, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AppService } from '../app.service';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Common } from '../common/common';
import { environment } from 'src/environments/environment';


declare var $;
declare var jQuery;
declare var google: any;
declare var gtag, fbq;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, AfterViewInit {

  public resiVerifyProperties: any = [];
  public commVerifyProperties: any = [];
  public agriVerifyProperties: any = [];
  public indusVerifyProperties: any = [];
  public resiVerifyPropertiesRent: any = [];
  public commVerifyPropertiesRent: any = [];
  public agriVerifyPropertiesRent: any = [];
  public indusVerifyPropertiesRent: any = [];
  public alwarBounds: any;
  public options: any;
  public display: boolean = true;
  soldProperties: any = [];
  topBrokers: any = [];
  trendingProjects: any = [];
  featuredProjects: any = [];
  keyword = 'name';
  cityList: any = [];
  initialValue: any = 'Alwar';
  eventName: any;
  eventValue: any;
  subCategoryArray:any;


  constructor(@Inject(PLATFORM_ID) private platformId: Object, private renderer: Renderer2, private route: ActivatedRoute, private router: Router, private service: AppService, private fb: FormBuilder, private spinner: NgxSpinnerService, private common: Common) {

    this.renderer.listen('window', 'click', (e: Event) => {
      if (isPlatformBrowser(this.platformId)) {
        if (!$(e.target).hasClass("ti-sharethis") && !$(e.target).hasClass("sharethis")) {
          $('.share_unit').removeClass('blockshareopt');
        }
      } else {
        this.display = false;
      }
    });

    this.initialValue = this.service.getSelectedCity.name;

    //check data if search data by city
    this.service.post('/getCityNameByState', { state_id: 33 }).subscribe((data: any) => {
      if (data[0].error == 0) {
        this.cityList = data[0].result;

        var cityName = this.route.snapshot.paramMap.get('city').split('-').pop();
        if (cityName != null) {

          var searchValue = this.cityList.filter(function (keyData) {
            return keyData.slug == cityName;
          });


          if (searchValue.length == 0) {

            this.router.navigateByUrl('404');

          }

        }

      }
    });

  }

  buyImage: any = "";
  rentImage: any = "";
  pgImage: any = "";
  advImg: any = "";
  advLink: any = "";

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      // $(window).resize(function(){
      //   if($(window).width() > 767){
      //     document.getElementById('search-box').style.cssText = 'display: block';
      //   }
      //   else{
      //     document.getElementById('search-box').style.cssText = 'display: none';
      //   }
      // });

      var data = localStorage.getItem('homesearch');

      this.router.events.subscribe((ev) => {
        if (ev instanceof NavigationEnd) {
          this.getVerifiedProperties('1', '2');
          this.getVerifiedPropertiesRent('1', '1');
          this.getFranchiseeList();
          this.getTrendingProject();
          this.getFeaturedProject();
        }
      });

      var showChar = 360;
      var ellipsestext = "...";
      $(".dream_property_alwar").each(function () {
        var content = $(this).html();
        if (content.length > showChar) {
          var c = content.substr(0, showChar);
          var h = content;
          var html =
            '<div class="truncate-text" style="display:block">' +
            c +
            '<span class="moreellipses">' +
            ellipsestext +
            '<a href="" style="color: #db0c0c;" class="dream_property_more_less more">Read more</a></span></div><div class="truncate-text" style="display:none">' +
            h +
            '<a href="" style="color: #db0c0c;" class="dream_property_more_less less">Read less</a></span></div>';

          $(this).html(html);
        }
      });

      $(".dream_property_more_less").click(function () {
        var thisEl = $(this);
        var cT = thisEl.closest(".truncate-text");
        var tX = ".truncate-text";

        if (thisEl.hasClass("less")) {

          cT.slideToggle();
          cT.prev(tX).toggle();
        } else {
          cT.toggle();
          cT.next(tX).fadeToggle();
        }
        return false;
      });

      var propertyTypeBox = document.getElementById('id01');
      var budgetTypeBox = document.getElementById('id02');

      // When the user clicks anywhere outside of the outbox box, close it
      window.onclick = function (event) {
        if (event.target == propertyTypeBox) {
          $('#flatoftype').toggleClass('type-class');
          $('#budgetlist').removeClass('budget-class');
        } else if (event.target == budgetTypeBox) {
          $('#budgetlist').toggleClass('budget-class');
          $('#flatoftype').removeClass('type-class');
        } else {
          $('#flatoftype').removeClass('type-class');
          $('#budgetlist').removeClass('budget-class');
        }

        $(document).ready(function () {
          $('.sharethis').click(function () {
            $('.share_unit').removeClass('blockshareopt');
            $(this).closest('.listing_actions').find('.share_unit').toggleClass("blockshareopt");
          });
        });
      }

      this.alwarBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
        new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
      );

      this.options = {
        bounds: this.alwarBounds,
        radius: 15,
        componentRestrictions: { country: 'IN' },
        strictBounds: environment.strictBounds
      }


    }

    this.elasticTabs();


    // load home data
    this.getHomePageImage();
    this.getBlogList();
    this.getTestimonialList();
    this.getPropertySnapshot();
    this.getVerifiedProperties('1', '2');
    this.getVerifiedPropertiesRent('1', '1');
    this.getFranchiseeList();
    this.getTrendingProject();
    this.getFeaturedProject();

    this.service.setTitle('Property in Alwar for Sale, Rent and Listing | Propira');
    this.service.setMetaTags({ name: 'keywords', content: 'Property in Alwar, Flats in Alwar, Real Estate Company Alwar, Apartments for Sale' });
    this.service.setMetaTags({ name: 'description', content: 'Propira is an independent real estate company in Alwar that is established to bring together buyers, sellers, tenants and agents under one roof.' });
    this.service.setMetaTags({ property: 'og:title', content: 'Property in Alwar for Sale, Rent and Listing | Propira' });
    this.service.setMetaTags({ property: 'og:description', content: 'Propira is an independent real estate company in Alwar that is established to bring together buyers, sellers, tenants and agents under one roof.' });

    this.service.post('/soldPropertyList', { "offset": "0", "limit": "4" }).subscribe((data) => {
      if (data[0].error == 0) {

        this.soldProperties = data[0].result;

      }
    });



  }

  get getSelectedCity() {
    return this.service.getSelectedCity;
  }

  getTrendingProject() {
    this.trendingProjects = [];
    this.service.post('/projectList', { "offset": "0", "limit": "10", "segment": "1", "city_id": this.service.getSelectedCity.id }).subscribe((data) => {
      if (data[0].error == 0) {
        Array.prototype.push.apply(this.trendingProjects, data[0].result);
        this.slider(".filter1", 5000, 2);


        setTimeout(() => {
          $('.filter1').owlCarousel({
            navigation: true,
            pagination: false,
            slideSpeed: 600,
            paginationSpeed: 400,
            autoPlay: true,
            autoplayTimeout: '5000',
            items: 2,
            itemsDesktop: [1199, 2],
            itemsDesktopSmall: [979, 2],
            itemsTablet: [767, 2],
            itemsMobile: [575, 1],
            navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
          });
        }, 100);
      }
    })

  }

  getFeaturedProject() {
    this.featuredProjects = [];
    this.service.post('/projectList', { "offset": "0", "limit": "10", "segment": "2", "city_id": this.service.getSelectedCity.id }).subscribe((data) => {
      if (data[0].error == 0) {
        Array.prototype.push.apply(this.featuredProjects, data[0].result);
        this.slider(".filter13", 5000, 2);

        setTimeout(() => {
          $('.filter13').owlCarousel({
            navigation: true,
            pagination: false,
            slideSpeed: 600,
            paginationSpeed: 400,
            autoPlay: true,
            autoplayTimeout: '5000',
            items: 3,
            itemsDesktop: [1199, 2],
            itemsDesktopSmall: [991, 2],
            itemsTablet: [767, 2],
            itemsMobile: [360, 1],
            navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
          });
        }, 100);
      }
    })

  }

  getFranchiseeList() {

    this.topBrokers = [];
    this.service.post('/franchiseList', { "offset": "0", "limit": "0", "city_id": this.service.getSelectedCity.id }).subscribe((data) => {
      if (data[0].error == 0) {

        this.topBrokers = data[0].result;
        this.slider(".filter4", 4000, 4);

        setTimeout(() => {
          $('.filter4').owlCarousel({
            navigation: true,
            pagination: false,
            slideSpeed: 600,
            margin: 10,
            paginationSpeed: 400,
            autoPlay: false,
            autoplayTimeout: '4000',
            items: 4,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [767, 2],
            itemsMobile: [460, 2],
            navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
          });
        }, 100);
      }
    })
  }

  getCity(event: any) {

    if (event != "") {
      $("#like").hide();
    }

    if (typeof event === 'object' && event !== null) {
      event.categoryType = this.searchCategory;
      event.showCategoryLabel = this.searchCategory;
      if (this.searchCategory == 'findAnAgent') {
        event.showCategoryLabel = 'find an agent';
      }
      localStorage.setItem('selSearchCity', JSON.stringify(event));

      this.router.navigate(['in/' + this.searchCategory + "/property-in-" + event.slug]);
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    }

    // if($(window).width() < 767)
    // {
    //   document.getElementById('search-box').style.cssText = 'display: none';
    // }

  }

  CityInputFocused() {
    $("#like").show();
  }

  ngAfterViewInit() {

    if (isPlatformBrowser(this.platformId)) {

      setTimeout(function () {
        $('#propertysuddenpopup').css('display', 'block');
      }, 10000);

      $('.closesuddenpopup').click(function () {
        $('#propertysuddenpopup').css('display', 'none');
      });

      this.slider(".filter", 5000, 3);
      this.slider(".filter8", 5000, 8);

      $(".by-budget").owlCarousel({
        navigation: true,
        pagination: false,
        slideSpeed: 600,
        paginationSpeed: 400,
        autoPlay: true,
        items: 4,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [767, 2],
        itemsMobile: [480, 1],
        navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
      });
    }
  }

  sliderImage: any = "";
  getHomePageImage() {
    this.service.get('/getHomepageBanner').subscribe(
      (data: any) => {
        this.buyImage = data[0].buy_image;
        this.sliderImage = data[0].buy_image;
        this.rentImage = data[0].rent_image;
        this.pgImage = data[0].pg_image;
      },
      error => {
        console.log(error.errorDesc);
      }
    )
  }

  testimonialList: any = [];
  getTestimonialList() {
    this.service.get('/testimonialList?featured=1').subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          this.testimonialList = data[0].result;
        }

      }, error => {
        console.log(error.errorDesc);
      }
    )
  }

  slider(cla, sliderspeed, index) {

    $(cla).owlCarousel({
      navigation: true,
      pagination: false,
      slideSpeed: 600,
      paginationSpeed: 400,
      autoPlay: true,
      autoplayTimeout: sliderspeed,
      items: index,
      itemsDesktop: [1199, 4],
      itemsDesktopSmall: [979, 3],
      itemsTablet: [767, 3],
      itemsMobile: [480, 2],
      navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
    });

  }



  blogList: any = [];
  getBlogList() {
    this.service.get('/homepageFeatBlog').subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          this.blogList = data[0].result;
          if (isPlatformBrowser(this.platformId)) {
            setTimeout(function () {
              $(".latest-blog").owlCarousel({
                navigation: false,
                pagination: true,
                slideSpeed: 600,
                paginationSpeed: 400,
                autoPlay: false,
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [979, 1],
                itemsTablet: [767, 1],
                itemsMobile: [480, 1],
                navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
              });
            })
          }
        }
      }, error => {
        console.log(error.errorDesc);
      }
    )
  }

  homeSearch = this.fb.group({
    looking_type: [''],
    propertytype_subcat: [''],
    location_lat: [''],
    location_long: [''],
    location: [''],
    location_sublocality: [''],
  })

  get f() { return this.homeSearch.controls; }

  handleAddressChange(event, type = '') {

    if (environment.production) {
      this.service.sendEvents("Completesearch_event", "search_event", "Search_Event");

      fbq('track', "CompleteSearch_Event", {
        content_term: this.searchCategory,
        content_type: event.formatted_address,
        content_title: this.router.url,
      });
    }
    this.eventName = event.name.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/[\s-]+/g, '-');

    if (type == 'mannual' && event.target.value == '') {
      this.homeSearch.patchValue({
        location_lat: '',
        location_long: '',
        location: '',
        location_sublocality: '',
      });
    } else if (type == 'address') {
      this.homeSearch.patchValue({
        location_lat: event.geometry.location.lat(),
        location_long: event.geometry.location.lng(),
        location: event.formatted_address,
        location_sublocality: event.address_components[0].long_name,
      });
    }
  }

  selectCategory(value: any) {
    if (value == '1') {
      this.homeSearch.patchValue({ propertytype_subcat: "1,2,4" });
    } else if (value == '2') {
      this.homeSearch.patchValue({ propertytype_subcat: "5,6,commercialland" });
    } else if (value == '3') {
      this.homeSearch.patchValue({ propertytype_subcat: "8,9" });
    } else if (value == '4') {
      this.homeSearch.patchValue({ propertytype_subcat: "10,13" });
    } else if (value == '5') {
      this.homeSearch.patchValue({ looking_type: "5", propertytype_subcat: "1,2,3" });
    }

    $('.collapse').removeClass('show');
    $('#collapse' + value).addClass('show');

  }

  propertyTypeValue() {
    var value = 'Select Property Type';
    if (this.f.propertytype_subcat.value) {
      this.subCategoryArray = this.f.propertytype_subcat.value.split(',');
      this.eventValue=this.subCategoryArray.toString()
      if (this.f.looking_type.value == '1' && this.subCategoryArray.length == 3) {
        value = 'All Residential';
      } else if (this.f.looking_type.value == '1' && this.subCategoryArray.length < 3) {
        value = 'Residential (' + this.subCategoryArray.length + ' Selected)';
      } else if (this.f.looking_type.value == '2' && this.subCategoryArray.length == 3) {
        value = 'All Commercial';
      } else if (this.f.looking_type.value == '2' && this.subCategoryArray.length < 3) {
        value = 'Commercial (' + this.subCategoryArray.length + ' Selected)';
      } else if (this.f.looking_type.value == '3' && this.subCategoryArray.length == 2) {
        value = 'All Agriculture';
      } else if (this.f.looking_type.value == '3' && this.subCategoryArray.length < 2) {
        value = 'Agriculture (' + this.subCategoryArray.length + ' Selected)';
      } else if (this.f.looking_type.value == '4' && this.subCategoryArray.length == 2) {
        value = 'All Industry';
      } else if (this.f.looking_type.value == '4' && this.subCategoryArray.length < 2) {
        value = 'Industry (' + this.subCategoryArray.length + ' Selected)';
      } else if (this.f.looking_type.value == '5' && this.subCategoryArray.length == 3) {
        value = 'PG Availability';
      } else if (this.f.looking_type.value == '5' && this.subCategoryArray.length < 3) {
        value = 'PG Availability(' + this.subCategoryArray.length + ' Selected)';
      }
    }

    return value;
  }
  

  setPropertySubCatValue(event) {
    var selCatValue = this.f.looking_type.value;
    var subCatValue = this.f.propertytype_subcat.value;
    var subCatSplit = subCatValue.split(",");

    if (((selCatValue == '1' || selCatValue == '2') && subCatSplit.length == 3) || (selCatValue == '3' && subCatSplit.length == 2) || (selCatValue == '4' && subCatSplit.length == 2) || (selCatValue == '5' && subCatSplit.length == 3)) {
      this.homeSearch.patchValue({ propertytype_subcat: event.target.value });
      this.eventValue=event.target.value;
      $('#checkbox' + event.target.value).prop('checked', true);
    } else {
      this.homeSearch.patchValue({ propertytype_subcat: $('.subcat:checked').map(function () { return this.value; }).get().join(',') });
    }
  }

  chkSearchSubTypeValue(id) {
    if (this.f.propertytype_subcat.value) {
      var idString = this.f.propertytype_subcat.value;
      var idArray = idString.split(',');

      var searchValue = idArray.filter(function (keyData) {
        return keyData == id;
      });

      if (searchValue.length > 0) {
        return searchValue[0];
      }
    }
  }

  mobileSearchFilter() {
    document.getElementById('search-box').style.cssText = 'display: block';
  }

  closeSearchFilter() {
    document.getElementById('search-box').style.cssText = 'display: none';
  }

  elasticTabs() {
    if (isPlatformBrowser(this.platformId)) {
      $(document).ready(function () {
        var tabs = $('.elasticTabs');
        var selector = $('.elasticTabs').find('a').length;
        var activeItem = tabs.find('.active');
        var activeWidth = activeItem.innerWidth();
        $(".selector").css({
          "left": activeItem.position.left + "px",
          "width": activeWidth + "px"
        });

        $(".elasticTabs").on("click", "a", function (e) {
          e.preventDefault();
          $('.elasticTabs a').removeClass("active");
          $(this).addClass('active');
          var activeWidth = $(this).innerWidth();
          var itemPos = $(this).position();
          $(".selector").css({
            "left": itemPos.left + "px",
            "width": activeWidth + "px"
          });
        });
      });
    }
  }

  searchCategory: string = this.getSelectedCity.categoryType;
  getBanner(value: string) {
    this.searchCategory = value;

    this.homeSearch.reset();

    var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));

    if (value == 'buy') {
      this.sliderImage = this.buyImage;
      selectedCityData.categoryType = 'buy';
      selectedCityData.showCategoryLabel = 'Buy';
    } else if (value == 'rent') {
      this.sliderImage = this.rentImage;
      selectedCityData.categoryType = 'rent';
      selectedCityData.showCategoryLabel = 'Rent';
    } else if (value == 'pg') {
      this.selectCategory('5');
      this.sliderImage = this.pgImage;
      selectedCityData.categoryType = 'pg';
      selectedCityData.showCategoryLabel = 'PG';
    }

    localStorage.setItem('selSearchCity', JSON.stringify(selectedCityData));

  }

  searchProperty() {

    $("body").scrollTop(0);
    var redirectUrl = this.searchCategory;

    var saleType = "";
    if (this.searchCategory == "buy") {
      saleType = "sale"
    } else if (this.searchCategory == "rent") {
      saleType = "rent";
    }

    if (this.searchCategory == 'findAnAgent') {
      redirectUrl = "/agent";
    } else if ((this.eventValue === '1' && this.homeSearch.value.looking_type == '1')) {
      if((this.f.looking_type.value == '1' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '1' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/residential-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/residential-for-'+saleType+'-in-'+this.getSelectedCity.slug + "/" + this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/residential-apartment-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '2' && this.homeSearch.value.looking_type == '1')) {
      if((this.f.looking_type.value == '1' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '1' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/residential-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/Independent-House-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/Independent-House-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '4' && this.homeSearch.value.looking_type == '1')) {
      if((this.f.looking_type.value == '1' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '1' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/residential-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/residential-plot-for-'+saleType+'-in-' +this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/residential-plot-for-'+saleType+'-in-' +this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '5'  && this.homeSearch.value.looking_type == '2')) {
      if((this.f.looking_type.value == '2' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '2' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/commercial-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/commercial-shops-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/commercial-shops-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '6' && this.homeSearch.value.looking_type == '2')) {
      if((this.f.looking_type.value == '2' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '2' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/commercial-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/commercial-office-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/commercial-office-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === 'commercialplot' && this.homeSearch.value.looking_type == '2')) {
      if((this.f.looking_type.value == '2' && this.subCategoryArray.length == 3)||(this.f.looking_type.value == '2' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/commercial-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/commercial-plot-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/commercial-plot-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '8' && this.homeSearch.value.looking_type == '3')) {
      if((this.f.looking_type.value == '3' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/agriculture-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/agriculture-land-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/agriculture-land-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '9' && this.homeSearch.value.looking_type == '3')) {
      if((this.f.looking_type.value == '3' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/agriculture-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/agriculture-farmhouse-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/agriculture-farmhouse-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '10' && this.homeSearch.value.looking_type == '4')) {
      if((this.f.looking_type.value == '4' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/industrial-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/industrial-land-for-'+saleType+'-in-' + this.getSelectedCity.slug+'/'+this.eventName;
      }else{
        redirectUrl = this.searchCategory + '/industrial-land-for-'+saleType+'-in-' + this.getSelectedCity.slug;
      }
    } else if ((this.eventValue === '13' && this.homeSearch.value.looking_type == '4')) {
      if((this.f.looking_type.value == '4' && this.subCategoryArray.length == 2)){
        redirectUrl = this.searchCategory + '/industrial-property-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }else if(this.eventName){
       redirectUrl = this.searchCategory + '/industrial-factory-for-'+saleType+'-in-'+this.getSelectedCity.slug+'/'+this.eventName;
      }
      else{
        redirectUrl = this.searchCategory + '/industrial-factory-for-'+saleType+'-in-'+this.getSelectedCity.slug;
      }
    }else if(this.eventName && this.homeSearch.value.looking_type == "1"){
      redirectUrl = this.searchCategory + '/residential-property-for-' + saleType + '-in-' + this.getSelectedCity.slug+'/'+this.eventName;
    }else if(this.eventName && this.homeSearch.value.looking_type == "2"){
      redirectUrl = this.searchCategory + '/commercial-property-for-' + saleType + '-in-' + this.getSelectedCity.slug+'/'+this.eventName;
    }else if(this.eventName && this.homeSearch.value.looking_type == "3"){
      redirectUrl = this.searchCategory + '/agriculture-for-' + saleType + '-in-' + this.getSelectedCity.slug+'/'+this.eventName;
    }else if(this.eventName && this.homeSearch.value.looking_type == "4"){
      redirectUrl = this.searchCategory + '/industrial-property-for-' + saleType + '-in-' + this.getSelectedCity.slug+'/'+this.eventName;
    } else if (this.homeSearch.value.looking_type && this.homeSearch.value.looking_type == '1') {
      redirectUrl = this.searchCategory + '/residential-property-for-' + saleType + '-in-' + this.getSelectedCity.slug;
    } else if (this.homeSearch.value.looking_type && this.homeSearch.value.looking_type == '2') {
      redirectUrl = this.searchCategory + '/commercial-property-for-' + saleType + '-in-' + this.getSelectedCity.slug;
    } else if (this.homeSearch.value.looking_type && this.homeSearch.value.looking_type == '3') {
      redirectUrl = this.searchCategory + '/agriculture-for-' + saleType + '-in-' + this.getSelectedCity.slug;
    } else if (this.homeSearch.value.looking_type && this.homeSearch.value.looking_type == '4') {
      redirectUrl = this.searchCategory + '/industrial-property-for-' + saleType + '-in-' + this.getSelectedCity.slug;
    } else if (this.searchCategory == "pg") {
      redirectUrl = this.searchCategory + "/pg-in-" + this.getSelectedCity.slug;
    } else if (this.eventName) {
      redirectUrl = this.searchCategory + "/property-in-" + this.getSelectedCity.slug + "/" + this.eventName;
    } else {
      redirectUrl = this.searchCategory + "/property-in-" + this.getSelectedCity.slug;
    }

    localStorage.setItem('homesearch', JSON.stringify(this.homeSearch.value));
    var homeSearch = JSON.parse(localStorage.getItem("homesearch"));

    if (environment.production) {
      this.googleFacbookAnyalytics(this.searchCategory, this.homeSearch.value.looking_type, "Search", redirectUrl);
    }
    this.router.navigateByUrl(redirectUrl);

  }

  googleFacbookAnyalytics(property_type: any, looking_type: any, action, redirectUrl) {
    var lookingType;
    if (looking_type == "1") {
      lookingType = "Residential"
    } else if (looking_type == "2") {
      lookingType = "Commercial"
    } else if (looking_type == "3") {
      lookingType = "Agriculture"
    } else if (looking_type == "4") {
      lookingType = "Industrial"
    }

    gtag('config', environment.gtagId, {
      'page_path': 'https://www.propira.com/' + redirectUrl
    });
    if (property_type === "rent") {
      this.service.sendEvents(
        "Rent",
        lookingType,
        action
      );
      this.triggerfacebookAnalytics("Rent", lookingType, redirectUrl, action)
    } else if (property_type === "buy") {
      this.service.sendEvents(
        "Buy",
        lookingType,
        action
      );
      this.triggerfacebookAnalytics("Buy", lookingType, redirectUrl, action)
    } else if (property_type === "pg") {
      this.service.sendEvents(
        "Pg",
        lookingType,
        action
      );
      this.triggerfacebookAnalytics("Pg", lookingType, redirectUrl, action)
    }
  }

  triggerfacebookAnalytics(eventCategory, lookingType, redirectUrl, events) {

    fbq(
      'init', environment.fbId, {
      'track': 'https://www.propira.com/' + redirectUrl
    }
    );
    fbq('track', events, {
      content_category: eventCategory,
      content_type: lookingType,
    });

  }


  getVerifiedProperties(type, property_type) {
    this.getLatestVerifiedProperties('1', '2');
    this.getLatestVerifiedProperties('2', '2');
    this.getLatestVerifiedProperties('3', '2');
    this.getLatestVerifiedProperties('4', '2');
  }

  getLatestVerifiedProperties(type, property_type) {
    this.service.get('/getVerifiedProperties?looking_type=' + type + '&city_id=' + this.service.getSelectedCity.id + '&limit=4&property_type=' + property_type).subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          if (type == '1') {
            this.resiVerifyProperties = data[0].result;

            if (this.service.isLoggedIn()) {
              var profileData = JSON.parse(localStorage.getItem('currentUser'));
              profileData.property_wishlistid = data[0].wishlist_id;
              localStorage.setItem('currentUser', JSON.stringify(profileData));
            }

          } else if (type == '2') {
            this.commVerifyProperties = data[0].result;
          } else if (type == '3') {
            this.agriVerifyProperties = data[0].result;
          } else {
            this.indusVerifyProperties = data[0].result;
          }
        }
      }, error => {
        console.log(error.errorDesc);
      }
    )
  }

  getVerifiedPropertiesRent(type, property_type) {
    this.getLatestVerifiedPropertiesRent('1', '1');
    this.getLatestVerifiedPropertiesRent('2', '1');
    this.getLatestVerifiedPropertiesRent('3', '1');
    this.getLatestVerifiedPropertiesRent('4', '1');
  }

  getLatestVerifiedPropertiesRent(type, property_type) {
    this.service.get('/getVerifiedProperties?looking_type=' + type + '&limit=4&property_type=' + property_type + '&city_id=' + this.getSelectedCity.id).subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          if (type == '1') {
            this.resiVerifyPropertiesRent = data[0].result;
          } else if (type == '2') {
            this.commVerifyPropertiesRent = data[0].result;
          } else if (type == '3') {
            this.agriVerifyPropertiesRent = data[0].result;
          } else {
            this.indusVerifyPropertiesRent = data[0].result;
          }
        }
      }, error => {
        console.log(error.errorDesc);
      }
    )
  }

  addToWishlist(property_type, property_id, event) {
    if (this.service.isLoggedIn()) {
      if (event.srcElement.classList.contains('fa-heart-o')) {
        event.srcElement.classList.remove('fa-heart-o');
        event.srcElement.classList.add('fa-heart');

        this.service.notificationPopup('success', 'Property successfully added in wishlist.');

      } else {
        event.srcElement.classList.remove('fa-heart');
        event.srcElement.classList.add('fa-heart-o');

        this.service.notificationPopup('success', 'Property successfully removed to wishlist.');
      }

      this.service.post('/addPropertyWishlist', { "type": "Web", "auth_token": this.service.getAuthorizationToken(), "property_type": property_type, "property_id": property_id }).subscribe(

        data => {
          if (data[0].error == '0') {

            var profileData = JSON.parse(localStorage.getItem('currentUser'));
            profileData.property_wishlistid = data[0].property_id;
            localStorage.setItem('currentUser', JSON.stringify(profileData));
          } else {
            this.service.messageBox('failed', 'Something went wrong.please try again.');
          }
        },
        error => {
          this.service.messageBox('failed', 'Something went wrong.please try again.');
        }
      )
    } else {
      $('#loginModal').modal('toggle');
    }

  }

  get chkPropertyWishlistId() { return this.service.getPropertyWishlistId; }


  propertysnapshot: any;
  getPropertySnapshot() {
    this.service.get('/propertySnapshotData').subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          this.propertysnapshot = data[0];
        }
      }, error => {
        console.log('in error');
      }
    )
  }

  sharePost(type, url) {
    this.common.sharePost(type, url);
  }

  openReadyHouseV() {
    this.homeSearch.patchValue({ looking_type: "1", propertytype_subcat: "1" });
    localStorage.setItem('homesearch', JSON.stringify(this.homeSearch.value));
    this.router.navigateByUrl("/search/buy/residential/" + this.getSelectedCity.slug);
  }

  openResiHouseVila() {
    this.homeSearch.patchValue({ looking_type: "1", propertytype_subcat: "2" });
    localStorage.setItem('homesearch', JSON.stringify(this.homeSearch.value));
    this.router.navigateByUrl("/search/buy/residential/" + this.getSelectedCity.slug);
  }

  openResiPlots() {
    this.homeSearch.patchValue({ looking_type: "1", propertytype_subcat: "4" });
    localStorage.setItem('homesearch', JSON.stringify(this.homeSearch.value));
    this.router.navigateByUrl("/search/buy/residential/" + this.getSelectedCity.slug);
  }

  top_View_All() {
    if (environment.production) {
      this.service.sendEvents("Completetop_projects_view_all", "top_projects_view_all", "Top_Projects_View_All");

      fbq('track', "CompleteTop_Projects_View_All", {
        content_type: "top_projects_view_all",
        content_title: this.router.url,
      });
    }
  }

  trending_View_All() {
    if (environment.production) {
      this.service.sendEvents("Completetrending_projects_view_all", "trending_projects_view_all", "Trending_Projects_View_All");

      fbq('track', "CompleteTrending_Projects_View_All", {
        content_type: "trending_projects_view_all",
        content_title: this.router.url,
      });
    }
  }

  latest_View_all() {
    if (environment.production) {
      this.service.sendEvents("Completelatest_property_sale_view_all", "latest_property_sale_view_all", "Latest_Property_Sale_View_All");

      fbq('track', "CompleteLatest_Property_Sale_View_All", {
        content_type: "latest_property_sale_view_all",
        content_title: this.router.url,
      });
    }
  }

  post_property() {
    if (environment.production) {
      this.service.sendEvents("Completepost_property", "post_property", "Post_Property");

      fbq('track', "CompletePost_Property", {
        content_type: "post_property",
        content_title: this.router.url,
      });
    }
  }

  latest_rent_View_all() {
    if (environment.production) {

      this.service.sendEvents("Completelatest_property_rent_view_all", "latest_property_rent_view_all", "Latest_Property_Rent_View_All");

      fbq('track', "CompleteLatest_Property_Rent_View_All", {
        content_type: "latest_property_rent_view_all",
        content_title: this.router.url,
      });
    }
  }

  property_expert_view_all() {
    if (environment.production) {
      this.service.sendEvents("Completeproperty_expert_view_all", "property_expert_view_all", "Property_Expert_View_All");

      fbq('track', "CompleteProperty_Expert_View_All", {
        content_type: "property_expert_view_all",
        content_title: this.router.url,
      });
    }
  }

  blog_view_all() {
    if (environment.production) {
      this.service.sendEvents("Completeblog_view_all", "blog_view_all", "Blog_View_All");

      fbq('track', "CompleteBlog_View_All", {
        content_type: "blog_view_all",
        content_title: this.router.url,
      });
    }
  }

}
